import { Outlet, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ThemeToggle, Isotype, LogoTitle } from "~/lib/theme";
import { LanguageSwitcher } from "~/components/LanguageSwitcher";

export function Layout() {
  const { t } = useTranslation();

  return (
    <div className="relative flex min-h-screen flex-col">
      {/* Skip to main content link for keyboard/screen reader users */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
      >
        {t("common.skipToContent", "Skip to main content")}
      </a>

      {/* Header with glass effect */}
      <header className="glass-header sticky top-0 z-50 w-full" role="banner">
        <div className="flex h-16 items-center justify-between px-4">
          <div className="flex items-center gap-1 w-20">
            <LanguageSwitcher variant="toggle" />
          </div>
          <Link to="/" className="flex items-center gap-3" aria-label={t("common.goToHome", "Go to home")}>
            <Isotype className="h-10 w-auto" alt="George Logo" />
            <LogoTitle className="h-6 w-auto hidden sm:block" alt="George" />
          </Link>
          <div className="flex items-center gap-1 w-20 justify-end">
            <ThemeToggle />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main id="main-content" className="flex-1" role="main" tabIndex={-1}>
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-background py-6 md:py-0" role="contentinfo">
        <div className="flex items-center justify-center md:h-14 px-4">
          <p className="text-center text-sm text-foreground/50">
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </p>
        </div>
      </footer>
    </div>
  );
}
